import Skeleton from '@mui/material/Skeleton';

const ProjectRowSkeleton = () => {
  return (
    <div className="projects-dashboard-list-project">
      <div className="projects-dashboard-list-item">
        <Skeleton variant="text" width="80%" />
      </div>

      <div className="projects-dashboard-list-item">
        <Skeleton variant="text" width="70%" />
      </div>

      <div className="projects-dashboard-list-item">
        <Skeleton variant="text" width="70%" />
      </div>

      <div className="projects-dashboard-list-item">
        <Skeleton variant="rounded" width={90} height={22} />
      </div>

      <div className="projects-dashboard-list-item">
        <Skeleton variant="text" width={30} />
      </div>

      <div className="projects-dashboard-list-item">
        <Skeleton variant="circular" width={28} height={28} />
      </div>
    </div>
  );
};
export default ProjectRowSkeleton;
